import { TFunction } from 'i18next';
import { ActivityCard } from '../ActivityCard';
import { CardContainer } from '../CardContainer';

interface ActivityCardContainerProps {
  t: TFunction<undefined>;
  toModerateData: number;
  toValidateData: number;
}

export const ActivityCardContainer = ({
  t,
  toModerateData,
  toValidateData,
}: ActivityCardContainerProps) => {
  return (
    <CardContainer>
      <div className="text-center font-semibold">{t('activities')}</div>
      <div className="mt-0.75 font-thin text-gray-252E49 text-sm text-center">
        {t('informationsOnInspections')}
      </div>
      <div className="mt-2.75 flex flex-wrap gap-3">
        <ActivityCard
          containerClassName="bg-blue-C1EDFF hover:cursor-default"
          // titleClassName="text-blue-72C1E3"
          titleClassName="text-blue-20BDFF"
          numberClassName="text-blue-20BDFF"
          title={t('toCheck')}
          description={t('moderationToDo')}
          number={toModerateData}
        />
        <ActivityCard
          containerClassName="bg-purple-DDD6FF hover:cursor-default"
          // titleClassName="text-purple-9D8AFF"
          titleClassName="text-purple-5433FF"
          numberClassName="text-purple-5433FF"
          title={t('toValidate')}
          description={t('clientVerifications')}
          number={toValidateData}
        />
      </div>
    </CardContainer>
  );
};
